import { render } from "./Home.vue?vue&type=template&id=70a65b6a"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=70a65b6a&lang=css"

import exportComponent from "E:\\GIT-铠甲\\jy-agreement\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__